import { VALUE_NAMES } from 'components/inboundReferrals/constants';
import { Dimensions } from 'components/insights/constants';
import { FilterSection } from 'components/shared/filters/FilterSlideout';
import { defaultFilterDropdownConfig } from 'constants/filterConfigs';
import { NONE_OPTION } from 'constants/filterKeysConstants';
import { SKILLED_NURSING_FACILITY } from 'constants/locationTypes';
import { useInfiniteAttrValues } from 'services/api/attrValue';
import { GroupAccessMode, useInfiniteGroups } from 'services/api/group';

// The receiving-SNF filter. Inbound referrals are only eligible for SNF groups, so scope options
// to the SNF group type (not all providers/LTC) among the groups the user can access. The backend
// facility dimension filters on workflow_groups.group_id, so the group id is the filter value.
export const SNF_DROPDOWN = {
  ...defaultFilterDropdownConfig,
  placeholder: 'Receiving SNF',
  name: Dimensions.FACILITY,
  getOptions: {
    hook: useInfiniteGroups,
    params: { sortBy: 'name asc', type: SKILLED_NURSING_FACILITY, accessModes: [GroupAccessMode.Allowed] },
  },
};

// The Referral Source filter. Options are the client's Referral Sources deduped by Display Value
// (distinctDisplayName), and the FE sends the Display Value string — matching the referral_source
// insights dimension, which reads the resolved Attr Value's display_name (OLIO-3010). Mirrors the
// list page's Referral Source filter (OLIO-3161) and the PHYSICIAN_TEAM attr-values dropdown.
// The prepended "None" option filters referrals with no resolved source — the insights dimension
// handles its null sentinel (OLIO-3010), same as the list-page filter.
export const REFERRAL_SOURCE_DROPDOWN = {
  ...defaultFilterDropdownConfig,
  placeholder: 'Referral Source',
  name: Dimensions.REFERRAL_SOURCE,
  getOptionValue: (obj) => obj.name,
  getOptions: {
    hook: useInfiniteAttrValues,
    params: { workflowValueName: VALUE_NAMES.REFERRAL_SOURCE, distinctDisplayName: true, active: true },
    optionsToPrepend: [NONE_OPTION],
  },
};

// The Payer Source filter. Same shape as Referral Source: options are the client's primary payers
// deduped by Display Value, and the FE sends the Display Value string — matching the payer_source
// insights dimension, which reads the resolved payer Attr Value's display_name (OLIO-3010 /
// OLIO-3218). The prepended "None" option filters referrals with no resolved payer.
export const PAYER_SOURCE_DROPDOWN = {
  ...defaultFilterDropdownConfig,
  placeholder: 'Primary Payer',
  name: Dimensions.PAYER_SOURCE,
  getOptionValue: (obj) => obj.name,
  getOptions: {
    hook: useInfiniteAttrValues,
    params: { workflowValueName: VALUE_NAMES.EXTERNAL_PAYER_NAME, distinctDisplayName: true, active: true },
    optionsToPrepend: [NONE_OPTION],
  },
};

export const getFilterSections = (): FilterSection[] => [
  { filters: [SNF_DROPDOWN, REFERRAL_SOURCE_DROPDOWN, PAYER_SOURCE_DROPDOWN] },
];
